import { styled } from 'styled-components';

import { layoutHeaderPanelIconSlotWidth } from './LayoutHeaderPanel.styled';

// Always rendered, even for rows without an icon, so labels line up
export const LayoutHeaderPanelRowIconHolder = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${layoutHeaderPanelIconSlotWidth}px;
  height: ${layoutHeaderPanelIconSlotWidth}px;

  img {
    width: ${layoutHeaderPanelIconSlotWidth}px;
    height: ${layoutHeaderPanelIconSlotWidth}px;
  }
`;

export const LayoutHeaderPanelRowLabel = styled.span`
  flex: 1;
`;
